export default "__VITE_ASSET__rYTHHfZL__"